window.hasClass = require('./has-class');
window.addClass = require('./add-class');
window.removeClass = require('./remove-class');
window.replaceClass = require('./replace-class');
window.toggleClass = require('./toggle-class');
